/**
 * @created on 2017/9/21
 * @author laixinyu <laixinyualex@gmail.com>
 **/

// 咨询-资金管理
const ConsultFundsIndex = resolve =>
  require(['../../../views/ConsultFundsIndex'], resolve)
const ConsultBalanceGuide = resolve =>
  require(['../../../views/ConsultBalanceGuide'], resolve)
const ConsultAuthentication = resolve =>
  require(['../../../views/ConsultAuthentication'], resolve)
const ConsultWithdrawalsSetting = resolve =>
  require(['../../../views/ConsultWithdrawalsSetting'], resolve)
const WithdrawalsPwdSettnig = resolve =>
  require(['../../../views/WithdrawalsPwdSettnig'], resolve)
const WithdrawalsAlipaySetting = resolve =>
  require(['../../../views/WithdrawalsAlipaySetting'], resolve)
const ConsultWithdrawals = resolve =>
  require(['../../../views/ConsultWithdrawals'], resolve)
const ConsultSigned = resolve =>
  require(['../../../views/consult/ConsultSigned'], resolve)
const ConsultWithdrawalsSucc = resolve =>
  require(['../../../views/ConsultWithdrawalsSucc'], resolve)
const InputWithdrawalsPwd = resolve =>
  require(['../../../views/InputWithdrawalsPwd'], resolve)
const BindingMobile = resolve =>
  require(['../../../views/BindingMobile'], resolve)
const WithdrawalsDetails = resolve =>
  require(['../../../views/WithdrawalsDetails'], resolve)

export default [
  // 资金管理
  {
    path: '/consult-funds-index',
    component: ConsultFundsIndex
  },
  {
    path: '/consult-balance-guide',
    component: ConsultBalanceGuide
  },
  {
    path: '/consult-authentication',
    component: ConsultAuthentication
  },
  {
    path: '/consult-withdrawals-setting',
    component: ConsultWithdrawalsSetting
  },
  {
    path: '/withdrawals-pwd-setting',
    component: WithdrawalsPwdSettnig
  },
  {
    path: '/withdrawals-alipay-setting',
    component: WithdrawalsAlipaySetting
  },
  {
    path: '/consult-withdrawals',
    component: ConsultWithdrawals
  },
  {
    path: '/consult-withdrawals-succ',
    component: ConsultWithdrawalsSucc
  },
  {
    path: '/input-withdrawals-pwd',
    component: InputWithdrawalsPwd
  },
  {
    path: '/binding-mobile',
    component: BindingMobile
  },
  {
    path: '/withdrawals-details',
    component: WithdrawalsDetails
  },
  {
    path: '/consult-signed',
    component: ConsultSigned
  }
]



// WEBPACK FOOTER //
// ./src/router/page/consult/capital.js